function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.4984 3.60017C23.2224 2.56751 22.4093 1.75437 21.3766 1.47842C19.5048 0.976806 11.9999 0.976807 11.9999 0.976807C11.9999 0.976807 4.49498 0.976806 2.62313 1.47842C1.5907 1.75437 0.777375 2.56751 0.501375 3.60017C0 5.47179 0 9.37685 0 9.37685C0 9.37685 0 13.2819 0.501375 15.1534C0.777375 16.186 1.5907 16.9993 2.62313 17.2753C4.49498 17.7767 11.9999 17.7767 11.9999 17.7767C11.9999 17.7767 19.5048 17.7767 21.3766 17.2753C22.4093 16.9993 23.2224 16.186 23.4984 15.1534C24 13.2819 24 9.37685 24 9.37685C24 9.37685 24 5.47179 23.4984 3.60017Z",
  fill: "#FAFAFA"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.59775 12.9757L15.833 9.37568L9.59775 5.77563V12.9757Z",
  fill: "#135FA5"
});

var SvgYoutubeIcon = function SvgYoutubeIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYoutubeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/youtube_icon.b4627022.svg";
export { ForwardRef as ReactComponent };